import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Badge, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export type AppDrawerButtonProps = {
    dataIndex: string;
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
    text: string;
    icon?: IconProp;
    secondaryAction?: React.ReactNode;
    badgeContent?: React.ReactNode;
    disabled?: boolean;
};

export default function AppDrawerButton(props: AppDrawerButtonProps): JSX.Element {
    const {
        dataIndex,
        onClick,
        text,
        icon,
        secondaryAction,
        badgeContent,
        disabled = false,
    } = props;

    return (
        <ListItemButton data-index={dataIndex} onClick={onClick} disabled={disabled}>
            <ListItemText primaryTypographyProps={{fontWeight: 'normal'}}> {text} {badgeContent}</ListItemText>
            {secondaryAction}
        </ListItemButton>
    );
}

